"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/CopyrightFooter.css");
var CopyrightFooter = /** @class */ (function (_super) {
    __extends(CopyrightFooter, _super);
    function CopyrightFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CopyrightFooter.prototype.render = function () {
        return (React.createElement("footer", { className: "box-shadow" },
            React.createElement(reactstrap_1.Container, null,
                React.createElement("h5", { className: "copyright-text" },
                    this.props.resources.Copyright_Anonymous,
                    " ",
                    this.props.version))));
    };
    return CopyrightFooter;
}(React.Component));
exports.CopyrightFooter = CopyrightFooter;
//# sourceMappingURL=CopyrightFooter.js.map